<template>
  <node-view-wrapper class="image-wrapper">
    <div class="relative group min-h-32 border border-surface-200 rounded-lg">
      <img
        :src="imageUrl"
        :alt="node.attrs.alt"
        class="w-full rounded-lg !m-0"
      />

      <div
        class="absolute inset-0 flex items-center justify-center transition-opacity rounded-lg cursor-pointer"
        :class="[
          imageUrl ? 'opacity-0 group-hover:opacity-100' : 'opacity-100',
          isLoading ? 'cursor-default' : 'cursor-pointer',
          { 'group-hover:bg-surface-900/50': !isLoading },
        ]"
        @click="triggerFileUpload"
      >
        <Button
          icon="fa-solid fa-upload"
          severity="secondary"
          size="small"
          rounded
          :loading="isLoading"
        />
      </div>

      <input
        ref="fileInput"
        type="file"
        accept="image/*"
        class="hidden"
        @change="handleFileChange"
      />
    </div>
  </node-view-wrapper>
</template>

<script setup lang="ts">
  import { ref, computed } from "vue";
  import { NodeViewWrapper } from "@tiptap/vue-3";
  import Button from "primevue/button";
  import ProgressSpinner from "primevue/progressspinner";

  const props = defineProps({
    node: {
      type: Object,
      required: true,
    },
    updateAttributes: {
      type: Function,
      required: true,
    },
  });

  const { uploadFile } = useFilesClient();

  const fileInput = ref<HTMLInputElement | null>(null);
  const isLoading = ref(false);

  const imageUrl = computed(() => props.node.attrs.src);

  const triggerFileUpload = () => {
    fileInput.value?.click();
  };

  const handleFileChange = async (event: Event) => {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;

    try {
      isLoading.value = true;

      const fileUrl = await uploadFile(file);
      props.updateAttributes({
        src: fileUrl,
      });
    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      isLoading.value = false;
    }
  };
</script>

<style lang="scss" scoped></style>
